<template>
    <div class="manage-account">

        <div class="flex-con is-grow">
            <div>
                <h2 class="title has-text-weight-light is-size-4 is-marginless is-paddingless">Account Details</h2>
            </div>
            <div class="has-text-right">
                <button class="button is-primary" @click="togglePasswordModal">
                    Change Password
                </button>
            </div>
        </div>

        <hr>

        <div class="flex-con is-equal is-grow md-pad-lr m-b-lg">
            <div>
                <div class="credit-con">
                    <h5 class="heading">Credit Available</h5>
                    <div><money :value="creditContext.creditAvailable" or="$0.00"></money></div>
                </div>
            </div>
            <div>
                <div class="credit-con">
                    <h5 class="heading">Credit Used</h5>
                    <div><money :value="creditContext.creditUsed" or="$0.00"></money></div>
                </div>
            </div>
        </div>

        <form @submit.prevent="updateAccount('account')" data-vv-scope="account">

            <div class="field">
                <label class="label">Email</label>
                <div class="control has-icons-left">
                    <input
                        class="input"
                        :class="{ 'is-danger' : errors.has('account.email') }"
                        type="email"
                        placeholder="Email"
                        v-model="account.email"
                        name="email"
                        v-validate="'email|required'"
                    />
                    <span class="icon is-left">
                        <i class="fa fa-envelope"></i>
                    </span>
                </div>
                <p v-show="errors.has('account.email')" class="help is-danger">{{ errors.first('account.email') }}</p>
            </div>

            <div class="columns is-no-pad-tb" style="margin-top:.75em;">
                <div class="column">
                    <div class="field">
                        <label class="label">First Name</label>
                        <div class="control">
                            <input
                                class="input"
                                :class="{ 'is-danger' : errors.has('account.first_name') }"
                                placeholder="First Name"
                                v-model="account.firstName"
                                name="first_name"
                                v-validate="'required'"
                            />
                        </div>
                        <p v-show="errors.has('account.first_name')" class="help is-danger">{{ errors.first('account.first_name') }}</p>
                    </div>
                </div>
                <div class="column">
                    <div class="field">
                        <label class="label">Last Name</label>
                        <div class="control">
                            <input
                                class="input"
                                :class="{ 'is-danger' : errors.has('last_name') }"
                                placeholder="Last Name"
                                v-model="account.lastName"
                                name="last_name"
                                v-validate="'required'"
                            />
                        </div>
                        <p v-show="errors.has('account.last_name')" class="help is-danger">{{ errors.first('account.last_name') }}</p>
                    </div>
                </div>
            </div>

            <div class="field">
                <label class="label">Phone</label>
                <div class="control has-icons-left">
                    <input
                        class="input"
                        :class="{ 'is-danger' : errors.has('account.phone') }"
                        placeholder="Phone"
                        v-model="account.phone"
                        name="phone"
                    />
                    <span class="icon is-left">
                        <i class="fa fa-phone"></i>
                    </span>
                </div>
                <p v-show="errors.has('account.phone')" class="help is-danger">{{ errors.first('account.phone') }}</p>
            </div>

            <div class="field">
                <label class="label">Company Name</label>
                <div class="control has-icons-left">
                    <input
                        class="input"
                        :class="{ 'is-danger' : errors.has('account.companyName') }"
                        placeholder="Company Name"
                        v-model="account.companyName"
                        name="companyName"
                    />
                    <span class="icon is-left">
                        <i class="fa fa-building-o"></i>
                    </span>
                </div>
                <p v-show="errors.has('account.companyName')" class="help is-danger">{{ errors.first('account.companyName') }}</p>
            </div>

            <div class="field">
                <label class="label">Website</label>
                <div class="control has-icons-left">
                    <input
                        class="input"
                        :class="{ 'is-danger' : errors.has('account.website') }"
                        placeholder="Your Website"
                        v-model="account.website"
                        v-validate="$store.state.dealer_portal.settings.website_required ? 'required|url' : 'url'"
                        name="website"
                    />
                    <span class="icon is-left">
                        <i class="fa fa-globe"></i>
                    </span>
                </div>
                <p v-show="errors.has('account.website')" class="help is-danger">{{ errors.first('account.website') }}</p>
            </div>

            <div v-if="$store.state.dealer_portal.settings.collect_tax_id" class="field">
                <label class="label">Tax ID</label>
                <div class="control has-icons-left">
                    <input
                        class="input"
                        :class="{ 'is-danger' : errors.has('account.taxId') }"
                        placeholder="Your Tax ID"
                        v-model="account.taxId"
                        v-validate="$store.state.dealer_portal.settings.collect_tax_id_required ? 'required' : null"
                        name="taxId"
                    />
                    <span class="icon is-left">
                        <i class="fa fa-suitcase"></i>
                    </span>
                </div>
                <p v-show="errors.has('account.taxId')" class="help is-danger">{{ errors.first('account.taxId') }}</p>
            </div>

            <!-- Address1 start-->
            <div class="field">
                <label class="label">Address1</label>
                <div class="control has-icons-left">
                    <input
                        class="input"
                        :class="{ 'is-danger' : errors.has('account.address.addressLine1') }"
                        placeholder="Address1"
                        v-model="account.address.addressLine1"
                        name="address1"
                    />
                    <span class="icon is-left">
                        <i class="fa fa-home"></i>
                    </span>
                </div>
                <p v-show="errors.has('account.address.addressLine1')" class="help is-danger">{{ errors.first('account.address.addressLine1') }}</p>
            </div>
            <!-- Address1 end-->

            <!-- Address2 start-->
            <div class="field">
                <label class="label">Address2</label>
                <div class="control has-icons-left">
                    <input
                        class="input"
                        :class="{ 'is-danger' : errors.has('account.address.addressLine2') }"
                        placeholder="Address2"
                        v-model="account.address.addressLine2"
                        name="address2"
                    />
                    <span class="icon is-left">
                        <i class="fa fa-home"></i>
                    </span>
                </div>
                <p v-show="errors.has('account.address.addressLine2')" class="help is-danger">{{ errors.first('account.address.addressLine2') }}</p>
            </div>
            <!-- Address2 end-->

            <!-- city start-->
            <div class="field">
                <label class="label">City</label>
                <div class="control has-icons-left">
                    <input
                        class="input"
                        :class="{ 'is-danger' : errors.has('account.address.city') }"
                        placeholder="City"
                        v-model="account.address.city"
                        name="city"
                    />
                </div>
                <p v-show="errors.has('account.address.city')" class="help is-danger">{{ errors.first('account.address.city') }}</p>
            </div>
            <!-- city end-->

            <!-- state start-->
            <div class="field">
                <label class="label">State</label>
                <div class="control has-icons-left">
                    <input
                        class="input"
                        :class="{ 'is-danger' : errors.has('account.address.state') }"
                        placeholder="State"
                        v-model="account.address.state"
                        name="state"
                    />
                </div>
                <p v-show="errors.has('account.address.state')" class="help is-danger">{{ errors.first('account.address.state') }}</p>
            </div>
            <!-- state end-->

            <!-- postal start-->
            <div class="field">
                <label class="label">Postal</label>
                <div class="control has-icons-left">
                    <input
                        class="input"
                        :class="{ 'is-danger' : errors.has('account.address.postal') }"
                        placeholder="Postal"
                        v-model="account.address.postal"
                        name="postal"
                    />
                </div>
                <p v-show="errors.has('account.address.postal')" class="help is-danger">{{ errors.first('account.address.postal') }}</p>
            </div>
            <!-- postal end-->

            <!-- country start-->
            <div class="field">
                <label class="label">Country</label>
                <div class="control has-icons-left">
                    <input
                        class="input"
                        :class="{ 'is-danger' : errors.has('account.address.country') }"
                        placeholder="Country"
                        v-model="account.address.country"
                        name="country"
                    />
                </div>
                <p v-show="errors.has('account.address.country')" class="help is-danger">{{ errors.first('account.address.country') }}</p>
            </div>
            <!-- country end-->

            <button class="button is-primary is-block-button" :class="{ 'is-loading' : updating }" type="submit">
                Update
            </button>

        </form>

        <modal :active="passwordModal.open" :close="togglePasswordModal">
            <form @submit.prevent="updatePassword('pw')" data-vv-scope="pw">

                <div class="field">
                    <label class="label">Current Password</label>
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('pw.current') }"
                            type="password"
                            placeholder="Current Password"
                            v-model="password.current"
                            name="current"
                            v-validate="'required'"
                        />
                        <span class="icon is-left">
                            <i class="fa fa-user-secret"></i>
                        </span>
                    </div>
                    <p v-show="errors.has('pw.current')" class="help is-danger">{{ errors.first('pw.current') }}</p>
                </div>

                <div class="field">
                    <label class="label">New Password</label>
                    <div class="control has-icons-left">
                        <input
                            class="input"
                            :class="{ 'is-danger' : errors.has('pw.new') }"
                            type="password"
                            placeholder="New Password"
                            v-model="password.newPassword"
                            name="new"
                            v-validate="'required|min:6'"
                        />
                        <span class="icon is-left">
                            <i class="fa fa-user-secret"></i>
                        </span>
                    </div>
                    <p v-show="errors.has('pw.new')" class="help is-danger">{{ errors.first('pw.new') }}</p>
                </div>

                <button class="button is-primary is-block-button" :class="{ 'is-loading' : passwordModal.loading }" type="submit">
                    Change Password
                </button>

            </form>

        </modal>

    </div>
</template>

<script>
import Dealer from '@/api/Dealer';

export default {
    name : "ManageAccount",
    data () {
        return {
            account : {
                email : this.$getDealer().email,
                firstName : this.$getDealer().firstName,
                lastName : this.$getDealer().lastName,
                phone : this.$getDealer().phone,
                taxId : this.$getDealer().taxId,
                companyName : this.$getDealer().companyName,
                website : this.$getDealer().website,
                creditAvailable : null,
                creditUsed : 0,
                address : {
                    addressLine1 : this.$getDealer().address.addressLine1,
                    addressLine2 : this.$getDealer().address.addressLine2,
                    city : this.$getDealer().address.city,
                    state : this.$getDealer().address.state,
                    country : this.$getDealer().address.country,
                    postal : this.$getDealer().address.postal,
                    id : this.$getDealer().address.id
                }

            },
            updating : false,
            passwordModal : {
                open : false,
                loading : false,
            },
            password : {
                current : null,
                newPassword : null,
            },
            creditContext : {
                loading : true,
                creditAvailable : null,
                creditUsed : null,
            },
        }
    },

    beforeMount () {
        Dealer.getAccountCredit().then(response => {
            Object.assign(this.creditContext, response.data);
            this.creditContext.loading = false;
        });
    },

    methods : {

        async updateAccount (form) {

            if(!(await this.$validator.validateAll(form))){
                this.$notify({
                    text : 'Please update the errors listed in red and try again',
                    type : 'error',
                });
                return;
            }

            this.updating = true;

            Dealer.postBasicInfo(this.$getDealer().id, this.account).then(() => {
                this.$notify({
                    text : 'Your account info has been updated',
                });
                const sessionContext = this.$getSessionContext();
                sessionContext.dealer = {...sessionContext.dealer, ...this.account};
                this.$store.commit('setSessionContext', sessionContext);
                this.updating = false;
            }).catch(error => {
                if(error.status === 409){
                    this.$notify({
                        text : 'That email address is already in use by another account',
                        type : 'error',
                    })
                }
                this.updating = false;
            });

        },

        togglePasswordModal () {
            if(this.passwordModal.open){
                this.password.current = null;
                this.password.newPassword = null;
            }
            this.passwordModal.open = !this.passwordModal.open;
        },

        async updatePassword (form) {

            if(!(await this.$validator.validateAll(form))){
                return;
            }

            this.passwordModal.loading = true;

            Dealer.postUpdatePassword(this.password).then(() => {
                this.$notify({
                    text : 'Your password has been updated!'
                });
                this.togglePasswordModal();
                this.passwordModal.loading = false;
            }).catch(error => {
                if(error.status === 406){
                    this.$notify({
                        text : 'Your current password is incorrect, please enter your correct current password and try again',
                        type : 'error',
                    })
                }
                this.passwordModal.loading = false;
            });

        }

    },

}
</script>

<style lang="scss" scoped>
    @import '../../assets/css/_theme';
    .manage-account {
        max-width:600px;
        margin:40px auto;
    }

    .credit-con {
        padding:10px;
        text-align:center;
        background-color:$white-ter;
        border-radius:5px;
        h5 {
            font-size:13px;
        }
        div {
            font-weight:bold;
            font-size:13px;
        }
    }
</style>
